<template>
  <div class="LoginCard" v-if="user.isLogin == false">
      <p class="name">高薪优质金融资本职位任你选</p>
      <el-button @click="setLoginPop(true)"><img src="@/common/images/talent/index/logincard (1).png" alt=""><p>登录</p></el-button>
      <el-button @click="setLoginPop(true)"><img src="@/common/images/talent/index/logincard (2).png" alt=""><p>注册</p></el-button>
  </div>
  <!-- 侧边栏登录 -->
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  name: 'LoginCard',
  data () {
    return {}
  },
  mounted () {
    console.log(this.user)
  },
  methods: {
    ...mapActions(['setLoading', 'setLoginPop'])
  },
  filters: {},
  watch: {
  },
  computed: {
    ...mapGetters([
        'user'
    ])
  },
  components: {
  }
}
</script>

<style lang="scss" type="text/scss">
.LoginCard {
    float: right;
    margin-top: 20px;
    width:300px;
    height:240px;
    text-align: center;
    background: url("../../../common/images/talent/index/logincard (3).png") no-repeat center center;
    background-size: 300px 240px;

    p.name {
        margin-top: 52px;
        font-size: 20px;
        color: #fff;
        text-align: center;
    }
    .el-button {
        margin-top: 20px;
        width:224px;
        height:40px;
        font-size: 16px;
        color: #fff;
        border-color: #2E7FFF;
        background: #2E7FFF;
        img {
          margin-left: 63px;
          margin-right: 6px;
          width: 20px;
          height: 20px;
          transform: translateY(-2px);
          -ms-transform: translateY(-2px);
          -webkit-transform: translateY(-2px);
          -moz-transform: translateY(-2px);
          -o-transform: translateY(-2px);
        }
        img,
        p {
          float: left;
        }
        &:last-child {
            border-color: #FFC75B;
            background: #FFC75B;
        }
    }
}
</style>